import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';

import { AuthService } from '@core/auth/auth.service';
import { FeedbackService } from '@shared/components/feedback/feedback.service';

@Component({
  selector: 'app-footer',
  imports: [],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  readonly isAuthenticated = toSignal(inject(AuthService).authState$.pipe(map((auth) => !!auth)), {
    initialValue: false,
  });

  private readonly feedbackService = inject(FeedbackService);

  openInNewTab(url: string) {
    if (url && url.trim() !== '') {
      const newTab = window.open(url, '_blank');
      if (newTab) {
        newTab.focus();
      }
    }
  }

  openFeedbackModal(): void {
    this.feedbackService.open();
  }
}
